export const normalizeBankRecipient = (b) => ({
    name: b?.name || "",
    accountNumber: b?.accountNumber || "",
    bankName: b?.bankName || "",
    bankCode: b?.bankCode || b?.accountCode || "",
    swiftCode: b?.swiftCode || "",
    currency: b?.currency,
    beneficiaryId: b?._id || b?.beneficiaryId || "",
    transactionId: b?.transactionId || "",
});

export const normalizeUsdRecipientForStore = (b) => {
    const meta = b?.meta || {};
    const accountType =
        meta.account_type ||
        b?.accountType ||
        (meta.iban || b?.iban ? "iban" : meta.swift || b?.swift ? "swift" : "us");

    const ownerType = meta.account_owner_type || b?.accountOwnerType || "";
    const isIndividual = ownerType === "individual";
    const isCorporate = ownerType === "corporate";

    const firstName = isIndividual ? meta.first_name || b?.firstName || "" : "";
    const lastName = isIndividual ? meta.last_name || b?.lastName || "" : "";
    const businessName = isCorporate ? meta.business_name || b?.businessName || "" : "";

    const accountOwnerName =
        meta.account_owner_name ||
        (isCorporate ? businessName : [firstName, lastName].filter(Boolean).join(" ").trim()) ||
        b?.name ||
        "";

    const address = meta.address || b?.address || {};
    const bankCountry = address.country || meta?.bank_country || "";

    const recipientBase = {
        bank_name: meta.bank_name || b?.bankName || "",
        account_type: accountType,
        account_owner_type: ownerType,
        first_name: firstName,
        last_name: lastName,
        business_name: businessName,
        account_owner_name: accountOwnerName,
        address: {
            street_line_1: address.street_line_1 || address.streetLine1 || "",
            street_line_2: address.street_line_2 || address.streetLine2 || "",
            city: address.city || "",
            state: address.state || "",
            subdivision: address.subdivision || "",
            postal_code: address.postal_code || address.postalCode || "",
            country: address.country || (accountType === "us" ? "US" : bankCountry || ""),
        },
    };

    let methodBlock = {};
    if (accountType === "iban") {
        const iban = meta.iban || b?.iban || {};
        methodBlock = {
            iban: {
                account_number: iban.account_number || iban.iban || "",
                bic: iban.bic || meta.bic || b?.bic || "",
                country: iban.country || recipientBase.address.country || "",
            },
        };
    } else if (accountType === "international_wire" || accountType === "swift") {
        const swift = meta.swift || b?.swift || {};
        methodBlock = {
            swift: {
                account_number: swift.account_number || b?.accountNumber || "",
                routing_number: swift.routing_number || "",
                bic: swift.bic || meta.bic || b?.bic || "",
                country: swift.country || recipientBase.address.country || "",
            },
        };
    } else {
        const acct = meta.account || b?.account || {};
        methodBlock = {
            account: {
                account_number: acct.account_number || b?.accountNumber || "",
                routing_number: acct.routing_number || "",
                checking_or_savings: acct.checking_or_savings || "",
            },
        };
    }

    return {
        accountOwnerType: ownerType,
        accountType,
        bankName: recipientBase.bank_name,
        accountOwnerName,
        firstName,
        lastName,
        businessName,
        recipient: {
            ...recipientBase,
            ...methodBlock,
        },
    };
};
